import { useEffect } from 'react';
import { snippet } from '@codemirror/autocomplete';

const EVENT_NAME = 'CodeEditorInsertSnippet';

export function insertSnippetAtCursor(detail) {
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
}

export function useSnippetInserter(editor) {
    useEffect(() => {
        function handler({ detail }) {
            const range = editor?.state?.selection?.ranges?.[0];

            if (!range) {
                return;
            }

            const apply = snippet(detail);
            apply(editor, {}, range.from, range.to);
            editor.focus();
        }

        document.addEventListener(EVENT_NAME, handler);
        return () => document.removeEventListener(EVENT_NAME, handler);
    }, [editor]);
}
